module.exports = __webpack_public_path__ + "static/media/patch-check-fill.41faa707.svg";